// src/components/technician-tabs/TabKannegiesser.js
import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Grid, TextField, Paper, Stack, Button, IconButton
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { useI18n } from '../../i18n/i18n';
import { getData } from '../../services/storageService';

const TabKannegiesser = ({ data, updateData }) => {
    const { t } = useI18n();
    const [staff, setStaff] = useState([]);
    const [assignments, setAssignments] = useState(null);
    const [localData, setLocalData] = useState(data || []);

    useEffect(() => {
        const fetchData = async () => {
            const staffData = await getData('staff') || [];
            setStaff(staffData.filter(s => s.status === 'active').map(s => s.name));
            
            const savedAssignments = await getData('ironing_assignments');
            setAssignments(savedAssignments);
        };
        fetchData();
    }, []);

    useEffect(() => {
        setLocalData(data || []);
    }, [data]);

    const handleInputChange = (index, field, value) => {
        const updatedData = localData.map((machine, i) => 
            i === index ? { ...machine, [field]: value } : machine
        );
        setLocalData(updatedData);
        updateData(updatedData);
    };

    const addMachine = () => {
        if (localData.length >= 4) return;
        const newMachine = {
            id: Date.now(),
            machine: localData.length + 1,
            worker1: '', worker2: '', worker3: '',
            pieces1: '', pieces2: '', pieces3: '', pieces4: '',
            total: ''
        };
        const updatedData = [...localData, newMachine];
        setLocalData(updatedData);
        updateData(updatedData);
    };

    const deleteMachine = (index) => {
        if (localData.length <= 1) return;
        const updatedData = localData.filter((_, i) => i !== index);
        setLocalData(updatedData);
        updateData(updatedData);
    };

    const MachineCard = ({ machine, index }) => {
        const assignment = assignments?.kannegiesser?.[index];

        return (
            <Paper sx={{ p: 2, mb: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6">
                        {t('ironing_kannegiesser_title')} {machine.machine || index + 1}
                    </Typography>
                    <IconButton 
                        onClick={() => deleteMachine(index)} 
                        color="error" 
                        disabled={localData.length <= 1}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Box>
                
                <Grid container spacing={2}>
                    {/* Працівники */}
                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" gutterBottom>{t('section_trabajadores')}</Typography>
                        <Stack spacing={2}>
                            {[1, 2, 3].map(workerNum => (
                                <TextField
                                    key={workerNum}
                                    select
                                    label={`${t('ironing_worker')} ${workerNum}`}
                                    value={machine[`worker${workerNum}`] || assignment?.[`worker${workerNum}`] || ''}
                                    onChange={(e) => handleInputChange(index, `worker${workerNum}`, e.target.value)}
                                    fullWidth
                                    size="small"
                                    SelectProps={{ native: true }}
                                >
                                    <option value=""></option>
                                    {staff.map(name => (
                                        <option key={name} value={name}>{name}</option>
                                    ))}
                                </TextField>
                            ))}
                        </Stack>
                    </Grid>

                    {/* Кількість деталей */}
                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" gutterBottom>{t('labels_kpi')}</Typography>
                        <Stack spacing={2}>
                            {[1, 2, 3, 4].map(pieceNum => (
                                <TextField
                                    key={pieceNum}
                                    label={t(`field_pieza${pieceNum}`)}
                                    type="number"
                                    value={machine[`pieces${pieceNum}`] || assignment?.[`pieces${pieceNum}`] || ''}
                                    onChange={(e) => handleInputChange(index, `pieces${pieceNum}`, e.target.value)}
                                    fullWidth
                                    size="small"
                                    inputProps={{ 
                                        min: "0",
                                        step: "1"
                                    }}
                                />
                            ))}
                            <TextField
                                label={t('field_total')}
                                type="number"
                                value={machine.total || ''}
                                onChange={(e) => handleInputChange(index, 'total', e.target.value)}
                                fullWidth
                                size="small"
                                inputProps={{ 
                                    min: "0",
                                    step: "1"
                                }}
                            />
                        </Stack>
                    </Grid>
                </Grid>
            </Paper>
        );
    };

    return (
        <Box>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', mb: 3 }}>
                {t('tech_form_tab_kannegiesser')}
            </Typography>
            
            {/* Картки машин */}
            {localData.map((machine, index) => (
                <MachineCard key={machine.id || index} machine={machine} index={index} />
            ))}
            
            <Button 
                startIcon={<AddIcon />} 
                onClick={addMachine} 
                disabled={localData.length >= 4}
                variant="outlined"
            >
                {t('btn_add_machine')}
            </Button>
        </Box>
    );
};

export default TabKannegiesser;